import axios from "axios";
import { previewSession } from "@/theme/previewProtocol";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Public storefront requests automatically carry the visitor's chosen language/currency so every
// page (shop, product, home...) stays consistent without needing to thread these params manually.
api.interceptors.request.use((config) => {
  const isThemePreview = !!previewSession();
  if (isThemePreview && !["get", "head", "options"].includes((config.method || "get").toLowerCase())) {
    return Promise.reject(new Error("Les commandes et envois sont désactivés dans l’aperçu du site."));
  }
  try {
    const locale = localStorage.getItem("levami_locale") || "fr";
    const currency = localStorage.getItem("levami_currency") || "eur";
    config.params = { lang: locale, currency, ...config.params };
  } catch {
    /* noop */
  }
  return config;
});

// Share simultaneous public reads only. No stored cache: subsequent visits,
// saved settings and prices still read fresh data from the normal API.
const pendingPublicReads = new Map();
export function getSharedPublic(path, params = {}) {
  let lang = "fr", currency = "eur";
  try {
    lang = localStorage.getItem("levami_locale") || lang;
    currency = localStorage.getItem("levami_currency") || currency;
  } catch { /* use interface defaults */ }
  const query = { lang, currency, ...params };
  const key = JSON.stringify([path, query]);
  if (pendingPublicReads.has(key)) return pendingPublicReads.get(key);
  const request = api.get(path, { params: query });
  pendingPublicReads.set(key, request);
  const release = () => { if (pendingPublicReads.get(key) === request) pendingPublicReads.delete(key); };
  request.then(release, release);
  return request;
}

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("levami_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("levami_admin_token");
      if (!window.location.pathname.includes("/admin/connexion")) {
        window.location.href = "/admin/connexion";
      }
    }
    return Promise.reject(err);
  }
);

export function getErrorMessage(err, fallback = "Une erreur est survenue. Veuillez réessayer.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) return "Vérifiez les informations saisies avant de réessayer.";
  return !err?.isAxiosError && typeof err?.message === "string" ? err.message : fallback;
}
